import { HTTP } from "./http";

let POSTS_API = "";
let COMMENTS_API = "";

if (window.location.href.indexOf("8080") > -1) {
  POSTS_API = "http://www.localhost:8888/back-end-endpoint-team-posts.php";
  COMMENTS_API = "http://www.localhost:8888/back-end-endpoint-post-comments.php";
} else {
  POSTS_API = "/personal-training-BE/back-end-endpoint-team-posts.php";
  COMMENTS_API = "/personal-training-BE/back-end-endpoint-post-comments.php";
}

const TeamPosts = {
  // Posts CRUD
  getPosts(teamId, page = 1, limit = 10) {
    return HTTP.post(POSTS_API, {
      action: "getPosts",
      teamId,
      page,
      limit,
    });
  },

  createPost(postData) {
    return HTTP.post(POSTS_API, {
      action: "createPost",
      ...postData,
    });
  },

  updatePost(postId, content, authorId) {
    return HTTP.post(POSTS_API, {
      action: "updatePost",
      postId,
      content,
      authorId,
    });
  },

  deletePost(postId) {
    return HTTP.post(POSTS_API, {
      action: "deletePost",
      postId,
    });
  },

  // Post reactions
  togglePostReaction(postId, emoji, userId) {
    return HTTP.post(POSTS_API, {
      action: "toggleReaction",
      postId,
      emoji,
      userId,
    });
  },

  // Pin post
  pinPost(postId, isPinned) {
    return HTTP.post(POSTS_API, {
      action: "pinPost",
      postId,
      isPinned,
    });
  },

  // Notifications
  notifyTeam(postData) {
    return HTTP.post(POSTS_API, {
      action: "notifyTeam",
      ...postData,
    });
  },
};

const PostComments = {
  // Comments CRUD
  getComments(postId) {
    return HTTP.post(COMMENTS_API, {
      action: "getComments",
      postId,
    });
  },

  createComment(commentData) {
    return HTTP.post(COMMENTS_API, {
      action: "createComment",
      ...commentData,
    });
  },

  updateComment(commentId, content, userId) {
    return HTTP.post(COMMENTS_API, {
      action: "updateComment",
      commentId,
      content,
      userId,
    });
  },

  deleteComment(commentId) {
    return HTTP.post(COMMENTS_API, {
      action: "deleteComment",
      commentId,
    });
  },

  // Comment reactions
  toggleCommentReaction(commentId, emoji, userId) {
    return HTTP.post(COMMENTS_API, {
      action: "toggleReaction",
      commentId,
      emoji,
      userId,
    });
  },
};

export { TeamPosts, PostComments };
